document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".lp-faq__item");

  // 最初の1つ目だけ開く
  if (faqItems.length > 0) {
    faqItems[0].classList.add("lp-faq__item--active");
    faqItems[0].querySelector(".lp-faq__question").setAttribute("aria-expanded", "true");
  }

  faqItems.forEach((item) => {
    const question = item.querySelector(".lp-faq__question");

    question.addEventListener("click", function () {
      item.classList.toggle("lp-faq__item--active");
      question.setAttribute("aria-expanded", item.classList.contains("lp-faq__item--active") ? "true" : "false");
    });
  });

  document.querySelectorAll('.smooth-scroll').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});
